var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsComponentsContainersEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22.249L12.5 17.249",
    stroke: "#676669",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.249L12.5 22.249",
    stroke: "#676669",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0133 2.5L6.48828 7.0375",
    stroke: "#676669",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9883 2.5L23.5133 7.0375",
    stroke: "#676669",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.8125C2.5 7.5 3.7375 7.3125 5.275 7.3125H24.725C26.2625 7.3125 27.5 7.5 27.5 9.8125C27.5 12.5 26.2625 12.3125 24.725 12.3125H5.275C3.7375 12.3125 2.5 12.5 2.5 9.8125Z",
    stroke: "#676669",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 12.5L6.1375 23.3C6.5375 25.725 7.5 27.5 11.075 27.5H18.6125C22.5 27.5 23.075 25.8 23.525 23.45L25.625 12.5",
    stroke: "#676669",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsComponentsContainersEmpty);
export default __webpack_public_path__ + "static/media/products-components-containers-empty.63b361c069e62218a9babb9068190995.svg";
export { ForwardRef as ReactComponent };